import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';


@Injectable()
export class SiteSettingsService {
  constructor(
    private _http: HttpService
    ) { }


  getSiteSetting(key: string): Observable<string> {
	  return this._http.get(environment.siteSettingsUrl + `?key=${key}`);
  }
}
